import { IApplicationState } from '../../types/redux';

export function selectPageCount(state: IApplicationState) {
  return state.pagination.pageCount;
}
